/* eslint-disable import/prefer-default-export */
import { createActions } from 'redux-actions';

const { toggleMapVisibility, toggleAutoCenterReading } = createActions({
	TOGGLE_MAP_VISIBILITY: () => ({}),
	TOGGLE_AUTO_CENTER_READING: () => ({})
});

export { toggleMapVisibility, toggleAutoCenterReading };
